import { render, staticRenderFns } from "./Video-Background.vue?vue&type=template&id=a083bf6a&"
import script from "./Video-Background.vue?vue&type=script&lang=js&"
export * from "./Video-Background.vue?vue&type=script&lang=js&"
import style0 from "./Video-Background.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a083bf6a')) {
      api.createRecord('a083bf6a', component.options)
    } else {
      api.reload('a083bf6a', component.options)
    }
    module.hot.accept("./Video-Background.vue?vue&type=template&id=a083bf6a&", function () {
      api.rerender('a083bf6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Video-Background.vue"
export default component.exports